import { useEffect, useState } from "react";
import { useAuth } from "../context/authContext";
import { BaseUrl } from "../enum/enum";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Login = () => {
    const {
        setToken,
        setUserId,
        setSessionId,
        setAccountId,
        setName,
        setPrefix,
        setEmail,
        setMobile,
        token,
        isAuthReady,
    } = useAuth();
    localStorage.setItem("setShowSale", '');

    const [status, setStatus] = useState("Pending");

    const navigate = useNavigate();
    // const location = useLocation();
    // const { accountId } = location.state || {};
    // const [error, setError] = useState("wallet not found");

    const bscParams = {
        chainId: '0x38', // 56 in hex
        chainName: 'Binance Smart Chain',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: ['https://bscscan.com/'],
    };

    const handleLogin = async (accountId) => {
        try {
            setStatus("Login started.");
            const url = `${BaseUrl}/MetaMask/LoginWithMetamask?Address=${accountId}`;

            const res = await axios.post(url);
            // console.log("res: ", res?.data);
            if (res.data?.statuscode == 1) {
                setStatus("Login successful.");
                toast.success(res.data.msg || "Login successfully.")

                const userAuth = {
                    token: res.data.data?.session,
                    email: res.data.data?.emailID,
                    name: res.data.data?.name,
                    mobile: res.data.data?.mobileNo,
                    sessionId: res.data.data?.sessionID,
                    userId: res.data.data?.userID,
                    prefix: res.data.data?.prefix,
                    accountId: accountId,
                };
                // console.log("saved data");
                localStorage.setItem("userAuth", JSON.stringify(userAuth));
                setUserId(userAuth.userId);
                setToken(userAuth.token);
                setSessionId(userAuth.sessionId);
                setAccountId(accountId);
                setPrefix(userAuth.prefix);
                setName(userAuth.name);
                setEmail(userAuth.email);
                setMobile(userAuth.mobile);

                setTimeout(() => {
                    navigate('/dashboard', { state: { loadBalance: true } });
                }, 200);
            } else if (res.data?.statuscode == 2) {
                setStatus("Login is invalid, redirecting to signup.");
                // toast.success(res.data.msg || "User not found.")
                navigate('/signup', {
                    state: {
                        accountId: accountId
                    }
                });
            } else {
                // console.log("statuscode is nither 1 or 2: ");
                toast.error(res.data.msg || "Something went wrong.")
                // setError(res.data.msg || "Something went wrong.");
            }

        } catch (e) {
            setStatus("Login: API error");
            console.log("catch: ", e.message);
            toast.error(e.messsage || "Something went wrong")
            // setError("Something went wrong.");
        }
    }

    const getAccounts = async () => {
        try {
            if (!window.ethereum) {
                toast.error("Wallet not found, Please install first.");
                setTimeout(() => {
                    window.open("https://metamask.io/download.html", "_blank");
                }, 500); // slight delay to let the toast show
                return;
            }
            setStatus("Waiting for dApp.");
            const existingAccounts = await window.ethereum.request({ method: "eth_accounts" });

            if (existingAccounts.length > 0) {
                setStatus("Wallet id found, switching to BEP20 network");
                switchToBSC(existingAccounts[0]);
                return;
            }

            const accs = await window.ethereum.request({ method: "eth_requestAccounts" });
            setStatus("Wallet id found, switching to BEP20 network");

            switchToBSC(accs[0]);
        } catch (err) {
            toast.error("Error fetching accounts: " + err.message);
        }
    };

    const switchToBSC = async (id) => {
        try {
            await window.ethereum?.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: bscParams.chainId }],
            });

            handleLogin(id);
        } catch (switchError) {
            // This error code means the chain hasn't been added to MetaMask
            if (switchError.code === 4902) {
                try {
                    await window.ethereum?.request({
                        method: 'wallet_addEthereumChain',
                        params: [bscParams],
                    });
                    handleLogin(id);
                } catch (addError) {

                }
            } else {

            }
        }
    }

    const manageAccount = () => {
        let counter = 0;
        getAccounts();
    }

    useEffect(() => {
        if (isAuthReady) {
            if (!token) {
                manageAccount();
            } else {
                navigate('/dashboard', { state: { loadBalance: true } });
            }
        }
    }, [isAuthReady, token]);

    return (
        <>
            {/* {
                error && <p style={{ color: "red" }}>
                    {error}
                </p>
            } */}
            <div className="d-flex-center" style={{ height: "100vh", fontSize: "24px" }}>
                <p>{status}</p>
            </div>
        </>
    )
}

export default Login;